function localizeTime(string, length = '') {
  const startTime = new Date(string); // Get event time
  let formattedText = '';

  // Check if time has duration
  if (length != '') {
    const startTimeOptions = {
      minute: 'numeric',
      hour: 'numeric',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };

    const endTimeOptions = {
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    };

    const endTime = new Date(startTime.getTime() + parseInt(length) * 60000);

    const formattedStartTime = Intl.DateTimeFormat(
      'en-US',
      startTimeOptions
    ).format(startTime);
    const formattedEndTime = Intl.DateTimeFormat(
      'en-US',
      endTimeOptions
    ).format(endTime);

    formattedText = formattedStartTime + ' to ' + formattedEndTime;
    formattedText = formattedText
      .replace('at', 'from')
      .replace(/ PM/g, 'PM')
      .replace(/ AM/g, 'AM');
  } else {
    const startTimeOptions = {
      minute: 'numeric',
      hour: 'numeric',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZoneName: 'short',
    };

    const formattedStartTime = Intl.DateTimeFormat(
      'en-US',
      startTimeOptions
    ).format(startTime);

    formattedText = formattedStartTime;
  }

  return formattedText;
}

// Localize time zone for single event pages
function localizeSingleTime(startTime, endTime) {
  const DateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  const timeFormatOptions = {
    minute: 'numeric',
    hour: '2-digit',
    timeZoneName: 'short',
  };

  const start = new Date(startTime);
  const end = new Date(endTime);

  const formattedDate = Intl.DateTimeFormat('en-US', DateOptions).format(start);
  const formattedStartTime = Intl.DateTimeFormat(
    'en-US',
    timeFormatOptions
  ).format(start);
  const formattedEndTime = Intl.DateTimeFormat(
    'en-US',
    timeFormatOptions
  ).format(end);

  const arr = [];
  arr['date'] = formattedDate;
  arr['start'] = formattedStartTime;
  arr['end'] = formattedEndTime;

  return arr;
}

export const timezoneConverter = () => {
  if (
    $('.woocommerce-input-wrapper select').length > 0 ||
    $('p.wc-event-date').length > 0
  ) {
    const userTimezone = Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
    }).format(new Date());

    // Hide timezone converter if user's timezone is EST
    if (!userTimezone.includes('EST') && !userTimezone.includes('EDT')) {
      $(
        "<p class='timezone-convert-btn' data-timezone='original'>View in your time zone</p>"
      ).insertAfter('form.cart');
    }

    document
      .querySelectorAll('.woocommerce-input-wrapper select')
      .forEach((select) => {
        select.querySelectorAll('option').forEach((option) => {
          if (option.value != '') {
            option.setAttribute('data-original-timezone', option.innerText);
          }
        });
      });

    document
      .querySelectorAll('.wc-event-date,.wc-start-time,.wc-end-time')
      .forEach((p) => {
        p.setAttribute('data-original-timezone', p.innerHTML.split('</b>')[1]);
      });

    $('.timezone-convert-btn').on('click', (e) => {
      const btn = e.target;
      if (btn.getAttribute('data-timezone') == 'original') {
        btn.innerText = 'View in original time zone';
        btn.setAttribute('data-timezone', 'local');
        const post_id = $('div.product')[0].id.split('-')[1];
        const timezone_array = 'post_' + post_id;

        // Convert single event pages to local time zone
        if (
          window[timezone_array] != undefined &&
          'event_start' in window[timezone_array]
        ) {
          let startTime = window[timezone_array]['event_start'];
          let endTime = window[timezone_array]['event_end'];
          const times = localizeSingleTime(startTime, endTime);

          document.querySelector('.wc-event-date').innerHTML =
            '<p><b>Date: </b>' + times['date'] + '</p>';
          document.querySelector('.wc-start-time').innerHTML =
            '<p><b>Start time: </b>' + times['start'] + '</p>';
          document.querySelector('.wc-end-time').innerHTML =
            '<p><b>End time: </b>' + times['end'] + '</p>';
        }

        // Convert booking slot pages to local time zone
        document
          .querySelectorAll('.woocommerce-input-wrapper select')
          .forEach((select) => {
            const post_id = $(select).find('option')[1].value.split('_')[2];
            const timezone_array = 'post_' + post_id;
            select.querySelectorAll('option').forEach((option) => {
              if (option.value != '') {
                option.innerText = localizeTime(
                  window[timezone_array][option.value],
                  window[timezone_array]['length']
                );
              }
            });
          });
      } else {
        btn.innerText = 'View in your time zone';
        btn.setAttribute('data-timezone', 'original');

        // Convert booking slots to original time zone
        document
          .querySelectorAll('.woocommerce-input-wrapper select')
          .forEach((select) => {
            select.querySelectorAll('option').forEach((option) => {
              if (option.value != '') {
                option.innerText = option.getAttribute(
                  'data-original-timezone'
                );
              }
            });
          });

        // Convert single events to original time zone
        document
          .querySelectorAll('.wc-event-date,.wc-start-time,.wc-end-time')
          .forEach((p) => {
            const arr = p.innerHTML.split('</b>');
            arr[1] = p.getAttribute('data-original-timezone');
            p.innerHTML = arr.join('</b>');
          });
      }
    });
  }
};
